import { Route, Redirect } from 'react-router-dom';
import {useSelector} from 'react-redux';

function PrivateRoute({ children, ...rest }) {
    const isAuthenticated = useSelector(state => state.auth.token !== null);
    const firstTimeChangedPwd = useSelector(state => state.auth.firstTimeChangedPwd);

    return (
        <Route {...rest} render={({location}) => {
            // If not authenticated, redirect to login
            if (!isAuthenticated) {
                return <Redirect to={{
                    pathname: '/login',
                    state: { from: location?.pathname }
                }} />;
            }

            // If authenticated but password hasn't been changed and not on /account page
            if (firstTimeChangedPwd === false && location?.pathname !== '/account') {
                return <Redirect to={{
                    pathname: '/account',
                    state: { from: location?.pathname }
                }} />;
            }

            // If everything is fine, render the children
            return children;
        }} />
    )
}

export default PrivateRoute;